import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';

@Component({
  selector: 'app-add-orders-to-trip',
  templateUrl: './add-orders-to-trip.component.html',
  styleUrls: ['./add-orders-to-trip.component.scss']
})
export class AddOrdersToTripComponent implements OnInit {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  OrderNo: any = {
    lable: 'Order',
    formControlName: 'OrderNo',
    dataField: 'OrderNo',
    isRequired: true,
    placeholder: 'Select OrderNo',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  ReasonValue:any;
  userId:any;
  CompanyId: any;
  @Input() BookingId:any;
  @Input() OrderId:any;
  @Input() CustomerId:any;
  @Input() OrderType:any;
  two_orderArray: any = [];
  
  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  getChangedValue(value, data){
    if(value){
      // this.ReasonValue = value.value;
      this.OrderNo.dropdownList = [];
      const existingOrder = this.two_orderArray.find(
        x => x.Id === value.value
      );

      if (existingOrder) {
        this.toastr.warning(
          `Order ${existingOrder.OrderNo} is already added`,
          'Warning'
        );

        setTimeout(() => {
          this.ReasonValue = null;
        });
        
        return;
      }

      const obj: any = {
        Id: value.value,
        OrderNo: value.name,
        ReferenceNo: value.ReferenceNo
      };

      this.two_orderArray.push(obj);

      setTimeout(() => {
        this.ReasonValue = null;
      });
      this.OrderNo.dropdownList = [];
    } else {
      this.ReasonValue = null;
    }
  }

  removeOrder(item: any) {
    this.two_orderArray = this.two_orderArray.filter(
      (i) => i.Id !== item.Id
    );
  }


  GetReasonList(value, isScrollDown = false) {
    this.OrderNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.OrderNo.dropdownList.length / 20) + 1;
    }
    this.orderService.GetOrderForAddIntoTrip(value, this.BookingId, this.CompanyId,this.CustomerId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.OrderNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.OrderNo.dropdownList);
        this.OrderNo = { ...this.OrderNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.OrderNo = { ...this.OrderNo, dropdownList: [...dropdownList] });
      this.OrderNo.isSearch = false;
    }).catch(error => {
      this.OrderNo.isSearch = false;
    })
  }

  Save() {
    Helpers.setLoading(true);

    if (!this.two_orderArray || this.two_orderArray.length === 0) {
      this.toastr.warning(
        "Please add at least one order before saving.",
        "Warning"
      );
      return;
    }

    this.two_orderArray.forEach((element) => {
      element.userId = this.userId;
      element.companyId = this.CompanyId;
      element.bookingId = this.BookingId;
    });
    console.log('two_orderArray',this.two_orderArray);

    this._appService.Post("OrdersByVehicle", "tmsApp_SaveOrderForAddIntoTrip", this.two_orderArray).subscribe(
      async (response) => {
        let resObj: any = response;
        let orderUnsuccessData: any = [];

        resObj.forEach((element) => {
          const orderData = this.two_orderArray.find(
            (i) => i.Id == element.orderId
          );

          if (orderData != null) {
            if (element.Reason !== "OK") {
              orderUnsuccessData.push(orderData);
            }

            element.OrderNo = orderData.OrderNo;
            element.Reason = element.Reason === "OK" ? "Success" : element.Reason;
          } else {
            element.OrderNo = "NA";
          }
        });

        this.two_orderArray = orderUnsuccessData;

        let messageStr = "";

        resObj.forEach((element) => {
          messageStr += `${element.OrderNo} - ${element.Reason}<br>`;
        });

        this.toastr.success(
          messageStr,
          "Order Status",
          { enableHtml: true }
        );

        Helpers.setLoading(false);
        this.Cancel();
        if(this.OrderType === 'FtlTripActions'){
          this.router.navigateByUrl('/FtlList');
        }
      },
      async (err) => {
        Helpers.setLoading(false);
        this.toastr.error(
          "Error occurred while adding order data!",
          "Error"
        );
      }
    );
  }
}
